module.exports = __webpack_public_path__ + "img/INT-1920.14745a47.jpg";